import { simpleIconsSvgUrl } from "./simpleIconsCurated";

export type CuratedNetworkIcon = {
  networkSlug: string;
  displayName: string;
  sourceSlug: string;
  brandHex: string;
  svgURL: string;
};

const sources = [
  ["visa", "Visa", "visa", "1A1F71"],
  ["mastercard", "Mastercard", "mastercard", "EB001B"],
  ["amex", "American Express", "americanexpress", "2E77BC"],
  ["discover", "Discover", "discover", "FF6000"],
  ["jcb", "JCB", "jcb", "0B4EA2"],
] as const;

export const CURATED_NETWORK_ICONS: CuratedNetworkIcon[] = sources.map(
  ([networkSlug, displayName, sourceSlug, brandHex]) => ({
    networkSlug,
    displayName,
    sourceSlug,
    brandHex,
    svgURL: simpleIconsSvgUrl(sourceSlug),
  }),
);
